/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : COMMENTING STATISTICS : STYLES --------------- ++++++++++ */
export default theme => ({
    statistics: {
        '& .control': {
            fontSize: pxToEm(15)
        },
        '& .table': {
            '& .tableview': {
                '& .tableelement': {
                    '& .thead': {
                        '& th': {
                            width: 'auto !important'
                        }
                    }
                }
            }
        },
        '& .link': {
            marginTop: '25px',
            width: '100%',
            justifyContent: 'center',
            '& span': {
                fontSize: '15px'
            }
        }

    }
});
